import { useTutorial } from '../../contexts/TutorialContext'

/**
 * TutorialStepRail — LOG n/8 strip. Desktop top-center; mobile shrinks to the
 * same strip (§4). Node states differ by shape/position/text, never hue alone.
 */
export default function TutorialStepRail({ currentStep }) {
    const { steps, state } = useTutorial()
    const completedThrough = (state?.current_step || currentStep || 1) - 1

    return (
        <div className="tcd-rail" role="status" aria-label={`Tutorial step ${currentStep} of ${steps.length}`}>
            <span className="tcd-rail__chip">{`LOG ${currentStep}/${steps.length}`}</span>
            {steps.map((s) => {
                let mod = 'future'
                if (s.id < currentStep || s.id <= completedThrough) mod = 'complete'
                else if (s.id === currentStep) mod = 'current'
                return <span key={s.id} className={`tcd-rail__node tcd-rail__node--${mod}`} aria-hidden="true" />
            })}
        </div>
    )
}
